import { render, staticRenderFns } from "./OuterGlowEffect.vue?vue&type=template&id=1bb8a24e"
import script from "./OuterGlowEffect.vue?vue&type=script&lang=js"
export * from "./OuterGlowEffect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports